import { createContext, useContext } from 'react';

import type { LoginState } from '@treneo/models';

export const LoginStateContext = createContext<LoginState | null>(null);

export const useLoginStateFromContext = (): LoginState | null => useContext(LoginStateContext);
